<template>
  <ProgressBar
    mode="indeterminate"
    style="height: 0"
    aria-label="Loading progress"
  />
</template>

<script>
import ProgressBar from 'primevue/progressbar';

export default {
  components: {
    ProgressBar,
  },
};
</script>
